var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "admin-users" } },
    [
      _c(
        "ma-modal",
        {
          ref: "userModal",
          attrs: { type: "small" },
          on: { "modal:close": _vm.resetModalUser }
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("p", { staticClass: "headline-large mg mg--b-1 black" }, [
                _vm._v(_vm._s(_vm.$t("users.modals.newUser.title")))
              ]),
              _c(
                "div",
                { staticClass: "grid mg mg--t-4" },
                [
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminUserFirstname",
                      col: 2,
                      icon: "house",
                      literal: "users.modals.user.fields.firstName"
                    },
                    model: {
                      value: _vm.modalUser.firstName,
                      callback: function($$v) {
                        _vm.$set(_vm.modalUser, "firstName", $$v)
                      },
                      expression: "modalUser.firstName"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminUserLastname",
                      col: 2,
                      icon: "house",
                      literal: "users.modals.user.fields.lastName"
                    },
                    model: {
                      value: _vm.modalUser.lastName,
                      callback: function($$v) {
                        _vm.$set(_vm.modalUser, "lastName", $$v)
                      },
                      expression: "modalUser.lastName"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminUserUsername",
                      col: 2,
                      icon: "house",
                      literal: "users.modals.user.fields.username"
                    },
                    model: {
                      value: _vm.modalUser.username,
                      callback: function($$v) {
                        _vm.$set(_vm.modalUser, "username", $$v)
                      },
                      expression: "modalUser.username"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminUserEmail",
                      col: 2,
                      icon: "house",
                      literal: "users.modals.user.fields.email"
                    },
                    model: {
                      value: _vm.modalUser.email,
                      callback: function($$v) {
                        _vm.$set(_vm.modalUser, "email", $$v)
                      },
                      expression: "modalUser.email"
                    }
                  }),
                  _c("ma-input-select-users", {
                    attrs: {
                      type: "select",
                      name: "adminUserCompany",
                      col: "2",
                      icon: "house",
                      literal: "users.modals.user.fields.company",
                      options: _vm.companyOptions,
                      value: _vm.modalUser.company
                    },
                    on: {
                      change: function($event) {
                        return _vm.handleChangeCompany($event)
                      }
                    }
                  }),
                  _c("ma-input-select-users", {
                    attrs: {
                      type: "select",
                      name: "adminUserRole",
                      col: "2",
                      icon: "house",
                      literal: "users.modals.user.fields.role",
                      options: _vm.roleOptions,
                      value: _vm.modalUser.role
                    },
                    on: {
                      change: function($event) {
                        _vm.modalUser.role = $event
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleNewUserSave }
                },
                [_vm._v(_vm._s(_vm.$t("actions.save")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: {
                    click: function($event) {
                      return _vm.closeModalAndRefreshForm("userModal")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c(
        "ma-modal",
        {
          ref: "editModal",
          attrs: { type: "small" },
          on: { "modal:close": _vm.resetModalUser }
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("p", { staticClass: "headline-large mg mg--b-1 black" }, [
                _vm._v(_vm._s(_vm.$t("users.modals.editUser.title")))
              ]),
              _c(
                "div",
                { staticClass: "grid mg mg--t-4" },
                [
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminUserFirstname",
                      col: 2,
                      icon: "house",
                      literal: "users.modals.user.fields.firstName"
                    },
                    model: {
                      value: _vm.modalUser.firstName,
                      callback: function($$v) {
                        _vm.$set(_vm.modalUser, "firstName", $$v)
                      },
                      expression: "modalUser.firstName"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminUserLastname",
                      col: 2,
                      icon: "house",
                      literal: "users.modals.user.fields.lastName"
                    },
                    model: {
                      value: _vm.modalUser.lastName,
                      callback: function($$v) {
                        _vm.$set(_vm.modalUser, "lastName", $$v)
                      },
                      expression: "modalUser.lastName"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminUserUsername",
                      col: 2,
                      icon: "house",
                      literal: "users.modals.user.fields.username",
                      disabled: ""
                    },
                    model: {
                      value: _vm.modalUser.username,
                      callback: function($$v) {
                        _vm.$set(_vm.modalUser, "username", $$v)
                      },
                      expression: "modalUser.username"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminUserEmail",
                      col: 2,
                      icon: "house",
                      literal: "users.modals.user.fields.email"
                    },
                    model: {
                      value: _vm.modalUser.email,
                      callback: function($$v) {
                        _vm.$set(_vm.modalUser, "email", $$v)
                      },
                      expression: "modalUser.email"
                    }
                  }),
                  _c("ma-input-select-users", {
                    attrs: {
                      type: "select",
                      name: "adminUserCompany",
                      col: "2",
                      icon: "house",
                      literal: "users.modals.user.fields.company",
                      options: _vm.companyOptions,
                      value: _vm.modalUser.company
                    },
                    on: {
                      change: function($event) {
                        return _vm.handleChangeCompany($event)
                      }
                    }
                  }),
                  _c("ma-input-select-users", {
                    attrs: {
                      type: "select",
                      name: "adminUserRole",
                      col: "2",
                      icon: "house",
                      literal: "users.modals.user.fields.role",
                      options: _vm.roleOptions,
                      value: _vm.modalUser.role
                    },
                    on: {
                      change: function($event) {
                        _vm.modalUser.role = $event
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleEditUserSave }
                },
                [_vm._v(_vm._s(_vm.$t("actions.save")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: {
                    click: function($event) {
                      return _vm.closeModalAndRefreshForm("editModal")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c(
        "ma-modal",
        {
          ref: "deleteModal",
          attrs: { type: "small" },
          on: { "modal:close": _vm.resetModalUser }
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("p", { staticClass: "headline-large mg mg--b-4 black" }, [
                _vm._v(_vm._s(_vm.$t("users.modals.deleteUser.title")))
              ]),
              _c("p", { staticClass: "mg mg--b-15 text-medium black" }, [
                _vm._v(_vm._s(_vm.$t("users.modals.deleteUser.body")))
              ]),
              _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
                _c(
                  "button",
                  {
                    staticClass: "mainBlue mg mg--r-2",
                    on: {
                      click: function($event) {
                        return _vm.handleDelete()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("actions.delete")))]
                ),
                _c(
                  "button",
                  {
                    staticClass: "secondaryBlue",
                    on: {
                      click: function($event) {
                        return _vm.closeModalAndRefreshForm("deleteModal")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
                )
              ])
            ])
          ])
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            {
              staticClass:
                "grid grid--jc-between grid--ai-middle mg mg--b-4 mg--t-2"
            },
            [
              _c("p", { staticClass: "headline-large" }, [
                _vm._v(_vm._s(_vm.$t("users.title")))
              ]),
              _c("span", [
                _c(
                  "button",
                  {
                    staticClass: "mainYellow",
                    on: { click: _vm.handleNewUserButtonClick }
                  },
                  [_vm._v(_vm._s(_vm.$t("users.newUser")))]
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "grid" },
            [
              _vm.stateUserIsSuperAdmin
                ? _c("ma-input-select", {
                    attrs: {
                      type: "select",
                      name: "adminUserCompanyFilter",
                      col: "1",
                      icon: "house",
                      literal: "users.filters.company",
                      options: _vm.companyOptions,
                      value: _vm.companyFilter,
                      nullValue: ""
                    },
                    on: { change: _vm.handleCompanyFilterChange }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("table", { staticClass: "table" }, [
            _c("thead", [
              _c("tr", { staticClass: "bg-blueDark" }, [
                _c("th", { staticClass: "border-right" }, [
                  _c("p", { staticClass: "text-medium white" }, [
                    _vm._v(_vm._s(_vm.$t("users.table.username")))
                  ])
                ]),
                _c("th", { staticClass: "border-right" }, [
                  _c("p", { staticClass: "text-medium white" }, [
                    _vm._v(_vm._s(_vm.$t("users.table.firstName")))
                  ])
                ]),
                _c("th", { staticClass: "border-right" }, [
                  _c("p", { staticClass: "text-medium white" }, [
                    _vm._v(_vm._s(_vm.$t("users.table.lastName")))
                  ])
                ]),
                _c("th", { staticClass: "border-right" }, [
                  _c("p", { staticClass: "text-medium white" }, [
                    _vm._v(_vm._s(_vm.$t("users.table.email")))
                  ])
                ]),
                _c("th", { staticClass: "border-right" }, [
                  _c("p", { staticClass: "text-medium white" }, [
                    _vm._v(_vm._s(_vm.$t("users.table.role")))
                  ])
                ]),
                _c("th", { staticClass: "no--border" }, [
                  _c("p", { staticClass: "text-medium white" }, [
                    _vm._v(_vm._s(_vm.$t("users.table.company")))
                  ])
                ]),
                _c("th", {
                  staticClass: "border-right",
                  attrs: { width: "50px" }
                })
              ])
            ]),
            _vm.hasData
              ? _c(
                  "tbody",
                  _vm._l(_vm.userTable, function(row) {
                    return _c("tr", [
                      _c("td", { staticClass: "border-right" }, [
                        _c(
                          "p",
                          {
                            staticClass: "text-medium black",
                            attrs: { title: row.username }
                          },
                          [_vm._v(_vm._s(row.username))]
                        )
                      ]),
                      _c("td", { staticClass: "border-right" }, [
                        _c(
                          "p",
                          {
                            staticClass: "text-medium black",
                            attrs: { title: row.first_name }
                          },
                          [_vm._v(_vm._s(row.first_name))]
                        )
                      ]),
                      _c("td", { staticClass: "border-right" }, [
                        _c(
                          "p",
                          {
                            staticClass: "text-medium black",
                            attrs: { title: row.last_name }
                          },
                          [_vm._v(_vm._s(row.last_name))]
                        )
                      ]),
                      _c("td", { staticClass: "border-right" }, [
                        _c(
                          "p",
                          {
                            staticClass: "text-medium black",
                            attrs: { title: row.email }
                          },
                          [_vm._v(_vm._s(row.email))]
                        )
                      ]),
                      _c("td", { staticClass: "border-right" }, [
                        _c(
                          "p",
                          {
                            staticClass: "text-medium black",
                            attrs: { title: row.role_name }
                          },
                          [_vm._v(_vm._s(row.role_name))]
                        )
                      ]),
                      _c("td", { staticClass: "no--border" }, [
                        _c(
                          "p",
                          {
                            staticClass: "text-medium black",
                            attrs: { title: row.company_name }
                          },
                          [_vm._v(_vm._s(row.company_name))]
                        )
                      ]),
                      _c("td", { staticClass: "text-align--right" }, [
                        _c(
                          "div",
                          { staticClass: "grid grid--jc-bottom" },
                          [
                            _c("svgicon", {
                              staticClass: "svg-icon-action",
                              attrs: {
                                name: "edit",
                                height: "16",
                                widht: "16"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleEditUserButtonClick(
                                    row.first_name,
                                    row.last_name,
                                    row.username,
                                    row.email,
                                    row.company_id,
                                    row.role_id
                                  )
                                }
                              }
                            }),
                            _c("svgicon", {
                              staticClass: "svg-icon-action mg mg--l-2",
                              attrs: {
                                name: "trash",
                                height: "16",
                                widht: "16"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleDeleteUserButtonClick(
                                    row.username
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  }),
                  0
                )
              : _vm._e()
          ]),
          _vm.hasData
            ? _c(
                "div",
                { staticClass: "grid grid--jc-bottom mg mg--t-4" },
                [
                  _c("ma-paginator", {
                    staticClass: "mg mg--t-2 mg--b-4",
                    attrs: { current: _vm.currentPage, total: _vm.totalPages },
                    on: {
                      "page:update": _vm.handlePageUpdate,
                      "page:set": _vm.handlePageSet
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.hasData
            ? _c("ma-empty", {
                attrs: {
                  icon: "recherche",
                  title: _vm.$t("common.noresults.short"),
                  descr: _vm.$t("common.noresults.long")
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }